<!--
 * @Author: RYL
 * @Description: 移动分组模块
 * @Date: 2021-02-26 16:59:34
 * @LastEditTime: 2021-03-01 16:44:42
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog title="移动分组" :visible.sync="dialogVisible" center width="40%">
      <div class="form-class">
        <el-form :model="moveData" ref="moveData" label-position="right" label-width="100px" :rules="rules">
          <el-form-item v-if="user_iscustomer==0||user_ctid!=0" :label="`${$t('lang.groupinglist.contact_to')}：`">
            <el-select
              :disabled="disabled"
              v-model="setuid"
              @change="userChange"
              :placeholder="$t('lang.groupinglist.Optional')"
              filterable
              clearable
              size="mini"
              style="width: 5rem">
              <el-option v-for="item in UserList" :key="item.user_id" :label="item.username" :value="item.user_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.groupinglist.group1')}：`">
            <el-select
              :disabled="disabled"
              v-model="setlevel1"
              value-key="group_id"
              :placeholder="$t('lang.groupinglist.selector')"
              size="mini"
              filterable
              clearable
              style="width: 5rem"
              @change="groupOneChane">
              <el-option 
                v-for="item in queryResult" 
                :key="item.group_id" 
                :disabled="moveData.group_id == item.group_id ? true : false"
                :label="item.group_name" 
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="setlevel1.group_id" :label="`${$t('lang.groupinglist.group2')}：`">
            <el-select
              :disabled="disabled"
              :placeholder="$t('lang.groupinglist.Choose')"
              size="mini"
              filterable
              clearable
              style="width: 5rem"
              v-model="setlevel2"
              value-key="group_id">
              <el-option 
                :disabled="moveData.group_id == item.group_id ? true : false"
                v-for="item in groupList" 
                :key="item.group_id" 
                :label="item.group_name" 
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
       
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.groupinglist.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="submitMove">{{$t('lang.groupinglist.Determine')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import { modifyGroupName, getAddLevel3Group, getUserList,getByUser, getByCustomer, getDetail } from "@/api/groupinglist";
export default {
  data() {
    return {
      dialogVisible: false,
      moveData: {},
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
      // 默認分組禁用状态
      disabled: false,
      UserList: [],
      queryResult: [],
      setuid: '',
      //修改分组二级选择框绑定
      setlevel1: { group_id: null },
      setlevel2: { group_id: null },
      rules: {
        group_name: [
          { required: true, message: this.$t('lang.groupinglist.groupNameInput'), trigger: 'blur'}
        ],
      },
      groupList: []
    }
  },
  methods: {
    show(row) {
      this.clearData()
      this.dialogVisible = true
      // 深拷贝
      this.moveData = JSON.parse(JSON.stringify(row))
       // 默认分组不能修改一二级分组
      this.disabled = row.group_level == 0 ? true : false
      // 所属用户
      if(this.user_iscustomer == 0 || this.user_ctid != 0){
        this.getUser()
        this.setuid = row.userGroups[0] ? row.userGroups[0].user.user_id : ''
        // 根据用户id查询分组
        this.fetchByUser()
      }else{ // 所属客户
        this.moveData.customer.c_id = row.customer && row.customer.c_id ? row.customer.c_id : ''
        this.fetchByCustomer()
      }
    },
    // 初始化数据
    clearData() {
       this.moveData = {
        n2nInfo: {
          n2nInfoStatus: 0
        },
        customer: {
          c_id: ""
        },
        groupParent: {
          group_id: null
        }
      }
      this.setlevel1 = { group_id: null }
      this.setlevel2 = { group_id: null }
      this.setuid = ''
    },
    // 获取用户列表
    getUser() {
      getUserList().then(res => {
        this.UserList = res.data.data.list;
      });
    },
    // 用户选择发生变化
    userChange(val) {
      // 清空原来的一二级分组选择
      this.setlevel1 = { group_id: '' }
      this.setlevel1 = { group_id: '' }
      this.fetchByUser()
    },
    // 根据客户ID查询一级分组
    fetchByCustomer() {
      this.queryResult = []
      getByCustomer(this.moveData.customer.c_id).then(res => {
        if(res.data.code === 0) {
          this.queryResult = res.data.data
        }
      })
    },
    // 根据用户ID查询一级分组
    fetchByUser() {
      this.queryResult = []
      getByUser(this.setuid).then(res => {
        if(res.data.code === 0) {
          this.queryResult = res.data.data
        }
      })
    },
    // 一级分组发生变化,清空二级分组
    groupOneChane(val) {
      this.setlevel2 = {}
      this.groupList = []
      this.getGroupTwo()
    },
    // 根据一级分组查找二级分组
    getGroupTwo() {
      if(this.setlevel1.group_id) {
        getAddLevel3Group(this.setlevel1.group_id).then((res)=>{
          this.groupList=res.data.queryResult
        })
      }
    },
    // 提交移动分组
    submitMove() {
      this.$refs.moveData.validate(valid => {
        let parentGroupId = null
        let group_level = null
        if(valid) {
          // 若选择了二级分组，则当前分组设置为三级分组
          if(this.setlevel2.group_id) {
            parentGroupId = this.setlevel2.group_id
            group_level = 3
          }else if(this.setlevel1.group_id) { // 选择一级分组，当前分组设为二级分组,
            parentGroupId = this.setlevel1.group_id
            group_level = 2
          }else{ // 不选择则当前分组为一级分组，没有选择一级分组时
            group_level = 1
            parentGroupId = 0
          }
        }
         //上传修改后的分组信息
          modifyGroupName(
            this.moveData.group_id,
            this.moveData.group_name,
            group_level,
            parentGroupId,
            this.setuid,
            this.moveData.customer.c_id,
            this.moveData.n2nInfo.n2nInfoStatus,
            this.moveData.n2nInfo.group_username,
            this.moveData.n2nInfo.group_password,
            this.moveData.n2nInfo.edge_ip,
            this.moveData.n2nInfo.n2nInfoLoginType,
            this.moveData.n2nInfo.n2nInfoLoginNum
          ).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: this.$t("lang.groupinglist.message4"),
                type: "success"
              });
            } else if (res.data.code === 21) {
              this.$message({
                message: this.$t("lang.groupinglist.message5"),
                type: "warning"
              });
            } else if (res.data.code === 28) {
              this.$message({
                message: this.$t("lang.groupinglist.message6"),
                type: "warning"
              });
            } else if (res.data.code === 19) {
              this.$message({
                message: this.$t("lang.groupinglist.message7"),
                type: "warning"
              });
            } else {
              this.$message({
                message: this.$t("lang.groupinglist.message8"),
                type: "warning"
              });
            }
            this.$emit('queryKeyword')
             // 清除选中状态
            this.$emit('cancelSelect')
            // 更新原来父级分组的数据和后来修改的父级分组的数据
            if(parentGroupId != this.moveData.groupPid) {
              this.$emit('reFleshTable', this.moveData.groupPid)
            }
            this.$emit('reFleshTable', parentGroupId)
           
            this.dialogVisible = false
          });
      })
    }
  }
}
</script>
<style scoped>
.form-class{
  display: flex;
  justify-content: center;
}
</style>
